import { loadStripe, type Stripe } from '@stripe/stripe-js';

export const loadStripeSafely = (key: string | undefined): Promise<Stripe | null> => {
  if (!key) {
    return Promise.resolve(null);
  }
  return loadStripe(key).catch(() => null);
};
